import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"fallback\":[\"system-ui\",\"arial\"],\"preload\":true}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/@cleartrip/ct-design-styles/dist/styles/index.css");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/app/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/atlassian/pipelines/agent/build/src/components/ct-design/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/components/modalContainer/globalModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/opt/atlassian/pipelines/agent/build/src/context/globalStateContext/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PubSubProvider"] */ "/opt/atlassian/pipelines/agent/build/src/context/pubSub/index.tsx");
